// Brand-aligned confetti burst for hire celebrations & stage advances.
// Heuristic: stage-advance notifications start with one of our emoji markers ("🎉","🥳","🚀",
// or "Hired") — used by the Layout poller to fire confetti on new ones.

import confetti from "canvas-confetti";

const BRAND_COLORS = ["#FF5C00", "#FFD600", "#0047FF", "#00E676", "#FF3AC5"];

let lastFiredAt = 0;
const COOLDOWN_MS = 800;

export function brandConfetti(opts = {}) {
  const now = Date.now();
  if (now - lastFiredAt < COOLDOWN_MS) return;
  lastFiredAt = now;

  const { intensity = "normal" } = opts;
  const particleCount = intensity === "big" ? 220 : 110;
  const spread = intensity === "big" ? 90 : 70;

  // Two cones from bottom-left and bottom-right for a "bento brutalist" feel
  confetti({
    particleCount: Math.round(particleCount / 2),
    spread,
    angle: 60,
    origin: { x: 0.05, y: 0.95 },
    colors: BRAND_COLORS,
    scalar: 0.95,
    ticks: 220,
  });
  confetti({
    particleCount: Math.round(particleCount / 2),
    spread,
    angle: 120,
    origin: { x: 0.95, y: 0.95 },
    colors: BRAND_COLORS,
    scalar: 0.95,
    ticks: 220,
  });
}

const HIRE_MARKERS = ["🎉", "🥳", "🚀", "hired", "Hired", "Passed Probation"];
const STAGE_MARKERS = ["→", "shortlisted", "Shortlisted", "interview", "offer", "Offer"];

export function detectCelebration(notification) {
  const t = `${notification?.title || ""} ${notification?.body || ""}`;
  if (HIRE_MARKERS.some((m) => t.includes(m))) return "big";
  if (STAGE_MARKERS.some((m) => t.toLowerCase().includes(m.toLowerCase()))) return "normal";
  return null;
}
